<template>
    <MeetingCard
        :meetingData="meetingData"
        :attendanceData="attendanceData"
        :reservationData="reservationData"
    >
        <template #actions>
            <AttendanceRescheduleButton
                :meeting="meetingData.meeting"
                :reservation="reservationData.reservation"
            />
            <AttendanceCancelButton
                :meeting="meetingData.meeting"
                :attendanceData="attendanceData"
                :reservationData="reservationData"
            />
        </template>
    </MeetingCard>
</template>

<script setup lang="ts">
    import MeetingCard from '@/BookingForm/BookingForm/Component/MeetingCard.vue'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import AttendanceRescheduleButton from '@/App/Booking/Meeting/Component/AttendanceRescheduleButton.vue'
    import AttendanceCancelButton from '@/App/Booking/Meeting/Component/AttendanceCancelButton.vue'
    import AttendanceData from '@/App/Booking/Attendance/Entity/AttendanceData'
    import ReservationData from '@/App/Booking/Reservation/Entity/ReservationData'

    interface ShowMeetingProps {
        meetingData: MeetingData
        attendanceData: AttendanceData
        reservationData: ReservationData
    }

    const props = defineProps<ShowMeetingProps>()
</script>
